import React from 'react';

import WarningIcon from '@core/assets/icons/warning-icon.svg';

import classes from './Message.module.scss';

const Message = ({ text, type, className }) => {
	const MessagType = () => {
		switch (type) {
			case 'warning':
				return (
					<div
						className={`${classes['warning-message']} d-flex flex-row align-items-center ${
							className || ''
						}`}>
						<WarningIcon /> <p>{text}</p>
					</div>
				);
			default:
				return <div> no type no message</div>;
		}
	};
	return <>{MessagType()}</>;
};

export default Message;
